import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IBackfillTranslationsRequest } from './backfill-translations-request';

export async function backfillTranslationsStreamApi(
  body: IBackfillTranslationsRequest = {},
): Promise<Response> {
  return postRawRequest({
    path: '/sys/challenges/backfill-translations/stream',
    body,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
